<template>
  <div class="bbp-project"
       :class="{
         'bbp-project_view-mode': viewMode,
         'bbp-project_blank': noSteps && completedProject,
         'bbp-project_no-completed': !completedProject
       }"
  >
    <span class="bbp-input bbp-project-header-name__input bbp-project-header-name__input_hide"
          ref="BBPProjectName">
      {{newProjectName}}
    </span>
    <div class="bbp-project-header"
         :class="{'bbp-project-header_completed': completedProject}"
         v-if="!viewMode">
      <label class="bbp-project-header-name"
             for="bbpProjectNameInput"
             :class="{
               'bbp-project-header-name_subproject': isSubproject,
               'bbp-project-header-name_subproject_without-checkbox': editNameProject && isSubproject
             }"
             v-click-outside="closeEditNameProject"
      >
        <div
          v-if="!isParentProject"
          class="bbp-project-header__button"
          :class="{'bbp-project-header__button_open': openProject}"
          @click="toogleProject"
        >
          <BBPIconArrows />
        </div>
        <BBPCheckbox
          v-if="isSubproject"
          v-show="!editNameProject"
          :item="project"
          ref="bbpCheckbox"
          @change="setCheckboxProject"
        />
        <div class="bbp-project-header__menu">
          <BBPToolbarMenu
            :hover="1"
            :row="{id: 1}"
            :column="{showEdit: true, isNoTriple: true}"
            :left="true"
            @edit="setEditNameProject"
            @delete="preDeleteProject"
          />
        </div>
        <div class="bbp-project-header__index">{{projectNumber}}</div>
        <span class="bbp-input bbp-project-header-name__input bbp-project-header-name__input_text"
              :class="{
                'bbp-project-header-name__input_text_completed': completedProject,
                'bbp-project-header-name__input_text_subproject': isSubproject
              }"
              @click="clickToName"
              v-if="!editNameProject">
          {{project.name}}
        </span>
        <input class="bbp-input bbp-project-header-name__input"
               :class="{'bbp-project-header-name__input_completed': completedProject}"
               id="bbpProjectNameInput"
               ref="BBPProjectNameInput"
               type="text"
               v-else
               @keyup.esc="editNameProject = false"
               @keyup.enter="updateProjectName"
               :disabled="!editNameProject"
               v-model.trim="newProjectName"
        />
        <transition-group name="bbp-fade-icons" mode="in-out">
          <i
            v-if="editNameProject"
            class="bbp-icon-save bbp-toolbar-save  bbp-project-header-name__icon"
            @click="updateProjectName"
            :key="'save'"
          />
        </transition-group>
      </label>
      <div class="bbp-project-header-update__container"
           :class="{'bbp-project-header-update__container_column': !completedProject && isSubproject}"
      >
        <div
          v-if="totalProjectTime"
          class="bbp-project-header-time bbp-project-header-time_pointer"
          @click="onShowHistoryTime"
        >
          <i class="bbp-icon-clock bbp-project-header-time__icon"/>
          <div class="bbp-project-header-time__text bbp-project-header-time__text_light">
            {{totalProjectTime}}
          </div>
        </div>
        <div v-else/>
        <div class="bbp-project-header-update"
             @click.stop="setCompleteProject"
             v-if="!completedProject && isSubproject">
          <i class="bbp-icon-save bbp-project-header-update__icon bbp-project-header-update__icon_complete"/>
          <span class="bbp-project-header-update__text">Complete</span>
        </div>
        <div class="bbp-project-header-managers">
          <div class="bbp-project-managers-project">
            <div class="bbp-project-managers-project__title">PM</div>
            <BBPSelectManager :manager="currentPM"
                              :type="'project'"
                              :limitCount="limitCount"
                              :supportManagers="[]"
                              :department="2"
                              :openListAddedManager="openListAddedManager"
                              @openListManager="openListManager"
                              @setManager="setManager"
                              :viewMode="viewMode || completedProject"
                              :index="projectIndex"/>
          </div>
          <div class="bbp-project-managers-project bbp-project-managers-project__supports">
            <div class="bbp-project-managers-project__title">Support</div>
              <BBPSelectManager class="bbp-project-managers-project-supports__item"
                                v-for="(manager, index) in supportManagers"
                                :index="index"
                                :supportManagers="supportManagers"
                                :key="manager._id + index"
                                :project="project"
                                :department="2"
                                :openListAddedManager="openListAddedManager"
                                :limitCount="limitCount"
                                @openListManager="openListManager"
                                :type="'support'"
                                :viewMode="viewMode || completedProject"
                                :manager="manager"
                                @setManager="setManager"/>
              <BBPSelectManager class="bbp-project-managers-project-supports__item"
                                v-if="openListAddedManager"
                                :key="'limit'"
                                :project="project"
                                :supportManagers="supportManagers"
                                :index="limitCount"
                                :department="2"
                                :openListAddedManager="false"
                                :limitCount="limitCount"
                                :type="'support'"
                                @openListManager="openListManager"/>
              <BBPSelectManager class="bbp-project-managers-project-supports__item"
                                v-if="!viewMode && !completedProject"
                                :supportManagers="supportManagers"
                                :key="'new'"
                                :set-on="true"
                                :department="2"
                                :project="project"
                                :openListAddedManager="openListAddedManager"
                                :limitCount="limitCount"
                                :type="'support'"
                                :manager="'new'"
                                @openListManager="openListManager"
                                @setManager="setManager"/>
          </div>
        </div>
        <div class="bbp-project-header-time">
          <span class="bbp-project-header-time__text">Started {{formatDate(project.commentStartDate)}}</span>
        </div>
        <div
          v-if="!completedProject"
          class="bbp-project-header-update"
          @click.stop="openUpdate"
        >
          <i class="bbp-icon-plus bbp-project-header-update__icon"/>
          <span class="bbp-project-header-update__text">{{textButton}}</span>
        </div>
      </div>
    </div>
    <VuePerfectScrollbar
      class="bbp-project-steps"
      :class="{
        'bbp-project-steps_without-padding': viewMode,
        'bbp-project-steps_min-mode': minViewMode,
        'bbp-project-steps_visibility': completedProject ? !project.$openEnd : !openProject
      }"
      ref="bbpStepsContainer"
    >
      <StepsNoData
        v-if="noStepsData"
        @openUpdate="openUpdate"
        :view-mode="viewMode || completedProject"
      />
      <StepCard
        v-else
        class="bbp-project-steps__card"
        :class="{'bbp-project-steps__card_last': stepIndex === projectSteps.length - 1}"
        :ref="'bbpStep' + stepIndex"
        v-for="(step, stepIndex) in projectSteps"
        :key="step.id"
        :project="project"
        :noEdit="completedProject"
        :minViewMode="minViewMode"
        :step="step"
        @openEdit="openEditStep"
        @loader="setLoader"
      />
      <div class="bbp-project-steps__padding" v-if="!noSteps"/>
    </VuePerfectScrollbar>
    <transition name="bbp-fade">
      <BBPModalWindow
        v-if="openStepForm"
        @close="closeStepForm"
      >
        <ProjectUpdateForm
          :hideSubProject="hideSubProject"
          :default-body="editableStep"
          :project="project"
          :clientProjects="clientProjects"
          @addStep="updateNotification"
          @updateGenerateInvoice="updateGenerateInvoice"
          @close="closeStepForm"
        />
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow
        v-if="openProjectForm"
        @close="closeProjectForm"
      >
        <BBPProjectForm :project="{client}"
                        :subproject="hourlyProject"
                        @update="addProjectToList"
                        @close="closeProjectForm"
                        @loader="setLoader"/>
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="openStatusModal" @close="closeStatusModal">
        <RequestChangeStatus :statusId="2"
                             title="State the reason why project has been lost:"
                             @save="saveStatusRequest"
                             @close="closeStatusModal"
                             :options="lostOptions"/>
      </BBPModalWindow>
    </transition>
    <transition name="bbp-fade">
      <BBPModalWindow v-if="isShowHistoryTime">
        <BBPTimeHistory
          :project="project"
          :totalProjectTime="totalProjectTime"
          :isShowHistoryTime.sync="isShowHistoryTime"
        />
      </BBPModalWindow>
    </transition>
  </div>
</template>

<script>
import ProjectsApi from '@/api/Projects/api'
import moment from 'moment'
import {cloneDeep, find, findIndex, get, includes, round, set, throttle} from 'lodash'
import BBPSelectManager from '@/components/Main/InputFields/BBPSelectManager/BBPSelectManager'
import StepsNoData from '@/components/Projects/ProjectCard/StepCard/StepsNoData'
import BBPModalWindow from '@/components/Main/BBPModalWindow/BBPModalWindow'
import BBPProjectForm from '@/components/Projects/ListOfProjects/BBPProjectForm'
import ProjectUpdateForm from '@/components/Projects/ProjectCard/ProjectUpdateForm/ProjectUpdateForm'
import StepsApi from '@/api/Steps/api'
import StepCard from '@/components/Projects/ProjectCard/StepCard/StepCard'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import scrollToElem from '@/mixin/scrollToElem'
import getNotification from '@/mixin/getNotification'
import NotificationApi from '@/api/Notification/api'
import {COMPLETED_PROJECT, DELETE_STATUS, LOST_PROJECT} from '@/constants/projectStatuses'
import {HOURLY, SIDE_HOURLY} from '@/constants/projectTypes'
import BBPCheckbox from '@/components/Main/InputFields/BBPCheckbox/BBPCheckbox'
import RequestChangeStatus from '@/components/Requests/RequestChangeStatus/RequestChangeStatus'
import BBPIconArrows from '@/components/Main/BBPIcons/BBPIconArrows'
import setProjectBody from '@/mixin/setProjectBody'
import BBPToolbarMenu from '@/components/Main/BBPTable/BBPToolbarMenu/BBPToolbarMenu'
import {LOST_OPTIONS, LOST_OPTIONS_DUPLICATE_ID, LOST_OPTIONS_OTHER_ID} from '@/constants/lostOptions'
import BBPTimeHistory from '@/components/Projects/ListOfProjects/BBPTimeHistory/BBPTimeHistory'
import convertSecondsToTime from '@/mixin/convertSecondsToTime'

export default {
  name: 'ProjectCard',
  components: {
    BBPTimeHistory,
    BBPIconArrows,
    BBPToolbarMenu,
    StepCard,
    ProjectUpdateForm,
    BBPModalWindow,
    StepsNoData,
    BBPSelectManager,
    BBPProjectForm,
    VuePerfectScrollbar,
    BBPCheckbox,
    RequestChangeStatus
  },
  mixins: [scrollToElem, getNotification, setProjectBody, convertSecondsToTime],
  props: [
    'project',
    'projectIndex',
    'clientProjects',
    'viewMode',
    'client',
    'projectNumber',
    'hideSubProject',
    'currentProject'
  ],
  data () {
    return {
      openStatusModal: false,
      scrollStepCounter: 0,
      openStepForm: false,
      openProjectForm: false,
      loaderRun: false,
      editNameProject: false,
      noSteps: false,
      newProjectName: '',
      currentPM: {},
      openControlStep: false,
      supportManagers: [],
      stepsLimit: 999,
      setTimeoutId: false,
      editableStep: {},
      limitCount: 4,
      openProject: false,
      includeInInvoice: false,
      openListAddedManager: false,
      checkboxElement: false,
      openConfirmDelete: false,
      popupDeletePosition: {},
      lostOptions: LOST_OPTIONS,
      isShowHistoryTime: false,
    }
  },
  computed: {
    removedStepsProject() {
      return this.$store.getters.removedStepsOfProject
    },
    totalProjectTime () {
      const { totalTime = 0 } = this.project
      const sec = Math.floor(totalTime / 1000)
      if (!sec) return false
      return this.convertSecondsToTime(sec, true)
    },
    completedProject () {
      const isCompleted = this.project.status === COMPLETED_PROJECT.id
      const isLost = this.project.status === LOST_PROJECT.id
      return isCompleted || isLost
    },
    noStepsData () {
      if (this.completedProject) return !this.projectSteps.length
      return this.noSteps && !this.completedProject && !this.isParentProject
    },
    isSubproject () {
      return get(this.project, 'projectType.id', '') === SIDE_HOURLY.id
    },
    isParentProject () {
      return get(this.project, 'projectType.id', '') === HOURLY.id
    },
    textButton () {
      return this.isNoSubProject ? 'Add Subproject' : 'Update'
    },
    isNoSubProject () {
      const { childrenProjects = [] } = this.project
      return this.isParentProject && !childrenProjects.length
    },
    hourlyProject () {
      return this.isNoSubProject ? this.project.id : this.project.parentProjectId
    },
    positionAdd () {
      const length = this.supportManagers.length
      if (this.openListAddedManager) {
        return length + 1
      }

      if (length <= this.limitCount) {
        return (length)
      }

      return this.limitCount + 1
    },
    projectsList () {
      return this.$store.getters.projectsList
    },
    userInfo () {
      return this.$store.getters.userInfo
    },
    setScrollLeft () {
      return throttle(this.scrollStepsTo, 500)
    },
    checkRouteProject () {
      return this.$route.name === 'ProjectCard'
    },
    minViewMode () {
      return this.$route.name === 'ListOfProjectByClient' || this.clientProjects.length > 1
    },
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    },
    stepsList: {
      get () {
        return this.$store.getters.stepsList
      },
      set (data) {
        this.$store.dispatch('setStepsList', data)
      }
    },
    projectId () {
      const { _id, id } = this.project
      return _id || id
    },
    projectSteps () {
      return get(this.stepsList, this.projectId, [])
    }
  },
  methods: {
    onShowHistoryTime () {
      this.isShowHistoryTime = !this.isShowHistoryTime
    },
    closeStatusModal () {
      this.openStatusModal = false
    },
    saveStatusRequest (comment) {
      const item = comment.find(({id}) => id === LOST_OPTIONS_DUPLICATE_ID || id === LOST_OPTIONS_OTHER_ID)
      set(this.project, 'status', item ? DELETE_STATUS.id : LOST_PROJECT.id)
      set(this.project, 'comments', comment.map(({text}) => text))
      this.closeStatusModal()
      this.updateProject()
    },
    closeConfirmDelete () {
      this.openConfirmDelete = false
      this.popupDeletePosition = {}
    },
    toogleProject () {
      this.openProject = !this.openProject
    },
    formatDate (date) {
      if (!date) return ''
      const momentDate = moment(date)
      const isValid = momentDate.isValid()
      return isValid ? momentDate.format('DD, MMM, YYYY') : ''
    },
    setOpenConfirmDelete (e, val) {
      this.openConfirmDelete = val
      const position = e.target.getBoundingClientRect()
      if (val && position) {
        this.popupDeletePosition = {
          position: 'fixed',
          top: position.top + 27 + 'px',
          right: 'auto',
          left: position.left - 50 + 'px'
        }
      } else {
        this.popupDeletePosition = {}
      }
    },
    openPopupStep (e) {
      const position = e.target.getBoundingClientRect()
      if (position) {
        this.popupPosition = {
          position: 'absolute',
          top: position.top + position.height + 5 + 'px',
          left: position.left - 34 + 'px'
        }
      }
      this.openControlStep = !this.openControlStep
    },
    preDeleteProject () {
      if (this.isSubproject) {
        this.deleteProject()
      } else {
        this.openStatusModal = true
      }
      this.closeConfirmDelete()
    },
    deleteProject () {
      const id = get(this.project, '_id', '')
      if (!id) return
      const index = findIndex(this.clientProjects, {_id: id})
      ProjectsApi.deleteProject(id)
        .then((resp) => {
          if (index !== -1) this.clientProjects.splice(index, 1)
        })
        .catch((err) => {
          console.error(err)
        })
    },
    addProjectToList (project) {
      if (this.isNoSubProject) {
        this.project.childrenProjects.push(project)
      } else {
        this.clientProjects.unshift(project)
      }
    },
    goToProjectCard () {
      this.$router.push({
        name: 'ProjectCard',
        params: {
          projectId: this.projectId
        }
      })
    },
    closeStepForm () {
      this.openStepForm = false
      this.editableStep = {}
    },
    openUpdate () {
      if (this.isNoSubProject) {
        this.openProjectForm = true
      } else {
        this.openStepForm = true
      }
    },
    setCompleteProject () {
      const { id, _id } = this.project
      const projectId = id || _id
      const index = findIndex(this.clientProjects, {_id: projectId})
      if (!projectId) return
      ProjectsApi.completeProject(projectId, COMPLETED_PROJECT.id)
        .then(resp => {
          if (index !== -1) {
            this.clientProjects.splice(index, 1)
          }
          this.clientProjects.push(resp.data)
        })
        .catch(err => {
          console.error(err)
        })
    },
    addProject () {
      this.openProjectForm = true
    },
    closeProjectForm () {
      this.openProjectForm = false
    },
    setLoader (val) {
      this.loaderRun = val
    },
    openEditStep (step) {
      this.editableStep = cloneDeep(step)
      this.openUpdate()
    },
    scrollStepsTo (factor) {
      const scrollContainer = get(this.$refs, 'bbpStepsContainer.$el', '')
      if (!scrollContainer) return
      const stepWidth = 440
      this.scrollStepCounter = round(scrollContainer.scrollLeft / stepWidth)
      const stepsDisplay = Math.floor(scrollContainer.offsetWidth / stepWidth)
      const limitMax = (this.projectSteps.length - stepsDisplay)
      const result = this.scrollStepCounter + factor
      const limitExceedMin = result < 0
      const limitExceedMax = result > limitMax
      if (this.scrollStepCounter === limitMax && factor === 1) return
      if (this.scrollStepCounter === 0 && factor === -1) return
      if (limitExceedMin) {
        this.scrollStepCounter = 0
      } else if (limitExceedMax) {
        this.scrollStepCounter = limitMax
      } else {
        this.scrollStepCounter = result
      }
      const elem = get(this.$refs, [`bbpStep${this.scrollStepCounter}`, 0, '$el'], '')
      this.scrollToElem(scrollContainer, elem, 500)
    },
    openListManager () {
      this.openListAddedManager = !this.openListAddedManager
    },
    setManager ({user, type, oldManager}) {
      // types: support: 1, project: 2
      if (type === 1) {
        this.setProjectSupports(user, oldManager)
      } else if (type === 2) {
        this.currentPM = user
        this.$set(this.project, 'projectManager', this.currentPM)
      }
      this.updateProject()
    },
    setProjectSupports (user, oldManager) {
      const oldManagerId = get(oldManager, '_id', '')
      const managerId = get(user, '_id', null)
      const managerIndexInProject = this.findIndexSupport(oldManagerId)
      const managerIndex = findIndex(this.supportManagers, {id: oldManagerId})
      if (managerId && oldManager === 'new') {
        this.supportManagers.push(user)
        this.project.supportManager.push(user)
      } else if (managerId && oldManagerId) {
        this.supportManagers.splice(managerIndex, 1, user)
        this.project.supportManager.splice(managerIndexInProject, 1, user)
      } else if (managerIndexInProject !== -1 && managerIndex !== -1) {
        this.supportManagers.splice(managerIndex, 1)
        this.project.supportManager.splice(managerIndexInProject, 1)
      }
    },
    findIndexSupport (id) {
      const manager = this.project.supportManager.map(item => item.id || item)
      return manager.indexOf(id)
    },
    getSupportManagers () {
      this.project.supportManager.forEach((managerId, index) => {
        if (index === 0) this.loaderRun = true
        if (typeof managerId === 'object') this.supportManagers.push(managerId)
      })
    },
    getContactPm () {
      const { projectManager = {} } = this.project
      this.currentPM = projectManager
    },
    closeEditNameProject () {
      this.editNameProject = false
    },
    setCheckboxProject ({value, item}) {
      this.updateChecked(value, item)
    },
    updateChecked (value, project) {
      this.includeInInvoice = value
      this.$emit('checked', {value, project, steps: this.projectSteps})
    },
    updateGenerateInvoice () {
      this.updateChecked(this.includeInInvoice, this.project)
    },
    clickToName () {
      if (!this.isSubproject) this.goToProjectCard()
      if (!this.isSubproject || !this.checkboxElement) return
      this.checkboxElement.setValue(!this.includeInInvoice)
    },
    setEditNameProject () {
      this.editNameProject = true
      this.newProjectName = this.project.name
      this.$nextTick(() => {
        const input = this.$refs.BBPProjectNameInput
        if (!input) return
        this.calcWidthInput(input)
        input.selectionStart = this.newProjectName.length
        input.focus()
      })
    },
    calcWidthInput (input) {
      const textNode = this.$refs.BBPProjectName
      const inputNode = input || this.$refs.BBPProjectNameInput
      if (!textNode || !inputNode) return
      inputNode.style.width = textNode.offsetWidth + 'px'
    },
    updateProjectName (e) {
      this.closeEditNameProject()
      this.project.name = this.newProjectName
      this.updateProject()
    },
    updateProject () {
      const isLost = this.project.status === LOST_PROJECT.id
      const index = findIndex(this.clientProjects, {id: this.project.id})
      const needUpdateList = index !== -1 && isLost
      const deletedProject = needUpdateList ? this.clientProjects.splice(index, 1) : []
      const project = this.setProjectBody(this.project)
      ProjectsApi.editProject(project)
        .then(resp => {
          return resp
        })
        .catch(err => {
          if (needUpdateList) {
            set(deletedProject, [0, 'status'], 1)
            this.clientProjects.splice(index, 0, ...deletedProject)
          }
          console.error(err)
        })
    },
    getSteps ({page}) {
      this.loaderRun = true
      StepsApi.getSteps({page, limit: this.stepsLimit, projectId: this.projectId})
        .then(resp => {
          this.loaderRun = false
          this.$set(this.stepsList, this.projectId, resp.data.steps)
          const noData = get(resp, 'data.steps.length', 0) === 0
          if (noData) this.noSteps = true
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
          this.noSteps = true
        })
    },
    async updateNotification () {
      const notifications = await this.getNotification({notificationType: 1, instanceId: this.projectId})
      const lastNotification = get(notifications, ['notifications', 0], {})
      const notificationId = get(lastNotification, 'id', '')
      const userID = get(this.userInfo, 'id', '')
      const readUsers = get(lastNotification, 'readUsers', [])
      if (includes(readUsers, userID) || !notificationId || !userID) return
      readUsers.push(userID)
      lastNotification.readUsers = readUsers
      NotificationApi.editNotification(lastNotification)
        .then(resp => {
          const targetProject = find(this.projectsList, {id: this.projectId}) || {}
          targetProject.$notification = resp.data
        })
        .catch(err => {
          console.error(err)
        })
    }
  },
  watch: {
    removedStepsProject(value) {
      const {subTimers, totalTime} = this.project;
      this.project.totalTime = totalTime - value.totalTime;
      this.project.subTimers =  subTimers.filter(timer => timer._id !== value._id);

      if (!this.projectSteps.length) {
       this.noSteps = true;
      }

    },
    loaderRun () {
      this.$emit('loader', this.loaderRun)
    },
    stepsList () {
      this.noSteps = this.projectSteps.length === 0
    },
    totalProjectTime () {
      const { childrenProjects = [] } = this.currentProject
      if (!childrenProjects.length) return
      const secondsTotal = childrenProjects.reduce((total, current) => total + (current.totalTime || 0), 0)
      this.currentProject.totalTime = secondsTotal
    }
  },
  mounted () {
    this.checkboxElement = this.$refs.bbpCheckbox
  },
  beforeMount () {
    if (this.checkRouteProject) {
      this.openProject = this.checkRouteProject
    }
    this.updateNotification()
    this.getSteps({})
    this.getSupportManagers()
    this.getContactPm()
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-project {
    @include global-font;
    border-radius: 5px;
    display: grid;
    grid-template-rows: 61px auto;
    align-items: start;
    width: 100%;

    &_no-completed {
      background: $color-white;
    }

    &_view-mode {
      grid-template-rows: 48px auto;
    }

    &-header {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      padding: 15px 20px 13px 10px;
      color: $color-accent;
      border-bottom: 2px solid $color-alabaster;
      background-color: $color-link-water;
      border-radius: 5px 5px 0 0;

      &__menu {
        position: relative;
      }

      &__index {
        width: 17px;
        height: 17px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        color: $color-denim;
        background: $color-sail;
        font-weight: bold;
        font-size: 11px;
        line-height: 13px;
      }

      &-icon {
        cursor: pointer;
        color: $color-denim;
      }

      &_completed {
        background-color: $color-peppermint;
      }

      &__remove {
        position: relative;
        margin-left: 12px;
        padding-left: 12px;

        &:after {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 1px;
          height: 21px;
          background-color: $color-mercury;
          transition: 0.3s;
        }
      }

      &__icon {
        position: relative;
        margin-left: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 21px;
        height: 21px;
        border-radius: 50%;
        background-color: $color-accent;
        color: $color-white;
        font-size: 10px;
        transform: rotate(180deg);
        transition: 0.3s;
        cursor: pointer;

        &:hover {
          background-color: $color-accent-hover;
        }

        &:after {
          content: '';
          position: absolute;
          right: -13px;
          width: 1px;
          height: 21px;
          background-color: $color-mercury;
          transition: 0.3s;
        }
      }

      &__button {
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        opacity: 1;
        transition: .3s linear;

        &_open {
          transform-origin: center center;
          transform: rotate(90deg);
        }

        &:hover {
          opacity: 0.8;
          transition: .3s linear;
        }
      }

      &-name {
        position: relative;
        display: grid;
        grid-template-columns: 20px auto auto auto 21px;
        justify-content: center;
        align-items: center;
        grid-gap: 0 5px;

        &_subproject {
          padding-left: 10px;
          grid-template-columns: 30px auto auto auto auto 21px;

          &_without-checkbox {
            padding-left: 25px;
            grid-template-columns: auto auto auto auto 21px;
          }
        }

        &__input {
          width: 100%;
          padding: 5px 10px;
          color: $color-accent;
          font-weight: 600;
          font-size: 16px;
          line-height: 19px;
          white-space: nowrap;
          cursor: text;
          transition: border-color 0.3s;
          background-color: $color-link-water;

          &_completed {
            color: $color-japanese-laurel;
            background-color: transparent;
          }

          &_text {
            border-color: transparent;
            background-color: $color-link-water;
            cursor: pointer;
            opacity: 1;
            transition: opacity .3s linear;

            &:hover {
              opacity: 0.8;
              transition: opacity .3s linear;
            }

            &_completed {
              color: $color-japanese-laurel;
              background-color: transparent;
            }

            &_subproject {
              cursor: pointer;
            }
          }

          &_hide {
            position: absolute;
            width: auto;
            opacity: 0;
            z-index: -1;
          }
        }

        &__icon {
          position: absolute;
          top: 5px;
          right: 0;
          font-size: 21px;
          margin-left: 16px;

          &:before {
            margin: 0;
          }
        }
      }

      &-managers {
        display: flex;
      }

      &-time {
        display: flex;
        align-items: center;

        &_pointer {
          cursor: pointer;
          transition: 0.15s;

          &:hover {
            opacity: 0.8;
          }
        }

        &__icon {
          font-size: 14px;
          line-height: 1;
          margin: 0 3px 0 0;
        }

        &__text {
          font-size: 14px;
          font-weight: bold;
          line-height: 17px;

          &_light {
            font-weight: 600;
          }
        }
      }

      &-update {
        display: flex;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        cursor: pointer;
        transition: 0.3s;
        padding: 0 0 0 12px;

        &_last-button {
          border-right: none;
          padding-right: 0;
        }

        &__container {
          margin-left: auto;
          display: grid;
          grid-gap: 69px 50px;
          grid-template-columns: 1fr auto 165px 130px;
          align-items: center;
          justify-content: start;

          &_column {
            grid-template-columns: 1fr auto auto 165px 130px;
          }
        }

        &:hover {
          color: $color-accent-hover;
        }

        &__icon {
          margin-right: 4px;
          font-size: 11px;

          &_complete {
            font-size: 16px;
          }
        }
      }
    }

    &-managers {
      display: flex;
      padding: 14px 20px 0;

      &_without-padding {
        padding: 14px 0 0;
      }

      &-project {
        margin-right: 13px;
        display: flex;
        align-items: center;

        &-supports {
          display: flex;

          &__item {
            position: relative;
          }
        }

        &__title {
          margin-right: 5px;
          color: $color-accent;
          font-weight: 600;
          font-size: 12px;
          line-height: 14px;
        }
      }

      &-controls {
        display: grid;
        grid-template-columns: 24px 24px;
        grid-gap: 4px;
        align-items: center;
        justify-content: center;
        margin-left: auto;
        margin-right: 0;

        &__item {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          border-radius: 50%;
          border: 1px solid $color-accent;
          background-color: $color-white;
          color: $color-accent;
          font-size: 11px;
          transition: 0.3s;
          cursor: pointer;

          &:hover {
            background-color: $color-accent;
            color: $color-white;
          }

          &_reverse {
            transform: rotate(180deg);
          }
        }
      }
    }

    &-steps {
      display: flex;
      overflow: hidden;
      padding: 27px 18px 19px 18px;
      margin-right: 18px;
      height: 315px;
      transition: .5s ease-in-out;

      &_visibility {
        padding: 0;
        height: 0
      }

      &_without-padding {
        margin-left: -18px;
      }

      &__card {
        margin-right: 20px;

        &_last {
          margin-right: 0;
        }
      }

      &__padding {
        width: 18px;
        min-width: 18px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Projects/ProjectCard/ProjectCard.vue